<template>
  <AdminLayout>
    <template #breadcrumb>
      <breadcrumb-link view="AdmitProviderList" :label="organization" />
      <breadcrumb-link
        view="ProviderUpdate"
        :params="{ id: provider.id }"
        :label="`Update ${provider.name}`"
        :active="true"
        v-if="!loading"
      />
    </template>
    <ProviderUpdateForm v-if="!loading" :is-for-admin="true" :provider="provider"></ProviderUpdateForm>
 </AdminLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import ProviderUpdateForm from '../../components/ProviderUpdateForm';
import AdminLayout from '../../layouts/AdminLayout.vue';
import request from '../../request';

export default {
  name: 'AdminProviderUpdate',
  components: {
    ProviderUpdateForm,
    AdminLayout,
  },
  data() {
    return {
      loading: true,
      provider: null,
    };
  },
  computed: {
    ...mapGetters(['organization']),
  },
  beforeRouteEnter(to, from, next) {
    request
      .get(`admin/providers/${to.params.id}`)
      .then((resp) => next((vm) => vm.setData(resp.data.provider)))
      .catch(() => next({ name: 'NotFound' }));
  },
  methods: {
    setData(provider) {
      this.provider = provider;
      this.loading = false;
    },
  },
};
</script>
